import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyBBl7Oc7yWbxJdaSjTaJU0yGzJ2aTdus4M",
    authDomain: "roles-react-52321.firebaseapp.com",
    databaseURL: "https://roles-react-52321.firebaseio.com",
    projectId: "roles-react-52321",
    storageBucket: "roles-react-52321.appspot.com",
    messagingSenderId: "260071456474",
    appId: "1:260071456474:web:9ee288dcd0ffd0a555efe3"
  };
 
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore()
const auth = firebase.auth()
const functions = firebase.functions()

export {db, auth, firebase, functions}